/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useCallback, useEffect, useRef, useState } from "react";
import MapBase from "./MapBase";
import WidgetClsCode from "./widgets/WidgetClsCode";
import WidgetVisibleRadius from "./widgets/WidgetVisibleRadius";
import { MapPropsProvider } from "./MapPropsContext";
import useMapProps from "./useMapProps";
import WidgetTableClicked from "./widgets/WidgetTableClicked";
import { formatUid, getApiUrl, makeTableSorterFn, positionToDegress } from "../../utils";
import WidgetContainer from "./widgets/WidgetContainer";
import { WELL_KNOWN_POSITION } from ".././../Constants";
import WidgetLegend from "./widgets/WidgetLegend";
import WidgetVworldCityTypeForCenter from "./widgets/WidgetVworldCityTypeForCenter";
import WidgetGeocoding from "./widgets/WidgetGeocoding";
import Seperator from "./widgets/Seperator";
import WidgetTableForSecureZone from "./widgets/WidgetTableForSecureZone";
import WidgetToolbar from "./widgets/WidgetToolbar";
import { message } from "antd";
import { TI_WIDGET_TABLE } from "../../Constants";
import EllipsisText from "./widgets/EllipsisText";  
import { WidgetButton } from "../../styled-components/Button";

const INITIAL_VIEW_STATE = {
  ...WELL_KNOWN_POSITION.남산공원,
  zoom: 16,
};

const ICON_MAPPING = {
  21: ["고정국", "고정국"],
  32: ["기지국", "기지국"],
  85: ["이동중계국", "이동중계국"],
  92: ["아마추어국", "아마추어국"],
  //  '81': ['전파응용1', '전파응용1'],
  //  '82': ['전파응용1', '전파응용1'],
  //  '83': ['전파응용1', '전파응용1'],
};

const ICON_CODE_BY_CLS_CODE = Object.entries(ICON_MAPPING).reduce((acc, [clsCode, [iconCode]]) => {
  acc[clsCode] = iconCode;
  return acc;
}, {});

const CLS_CODE_OPTIONS = Object.entries(ICON_MAPPING).map(([clsCode, [iconCode, iconLabel]]) => {
  return { cls_code: clsCode, label: iconLabel };
});

message.config({
  top: 250,
  duration: 15,
  maxCount: 1,
});

const infoByZoom = () => {
  message.info({
    content: <span style={{ fontSize: 15 }}> 해당 zoom에서는 검색이 불가합니다. 확대해 주시기 바랍니다.</span>,
  });
};

const MapStation = () => {
  const [isTableVisible, setTableVisible] = useState(false);
  const mapProps = useMapProps({
    INITIAL_VISIBLE_RADIUS: 500,
    INITIAL_VIEW_STATE,
    INITIAL_POINT_LAYER_PROPS: {
      getIconCode: ({ cls_code, rad_cls_cd }) => {
        try {
          return ICON_MAPPING[cls_code || rad_cls_cd][0];
        } catch (e) {
          console.error("not found iconCode for", cls_code, rad_cls_cd);
          return null;
        }
      },
      getIconWidth: (feature, zoom) => {
        let iconWidth = 30;
        if (zoom <= 12) {
          iconWidth -= (iconWidth * (15 - Math.max(7, zoom))) / 11;
          return Math.min(25.2, iconWidth);
        } else if (zoom <= 13) {
          iconWidth -= (iconWidth * (15 - Math.max(7, zoom))) / 5;
          return Math.min(25.2, iconWidth);
        } else if (zoom <= 14) {
          iconWidth -= (iconWidth * (15 - Math.max(7, zoom))) / 3;
          return Math.min(25.2, iconWidth);
        } else if (zoom === 15) {
          iconWidth -= (iconWidth * (16 - Math.max(7, zoom))) / 4;
          return Math.min(30, iconWidth);
        } else if (zoom >= 16) {
          return 30;
        }
      },
    },
    // INITIAL_GEOJSON_POLYGON_LAYER_PROPS: {
    //   getFillColor: (feature) => {
    //     return [0, 0, 255];
    //   },
    // },
    INITIAL_LAYER_WMS_TYPES: [],
    INITIAL_WIDGET_STATE: {
      cls_code_list: Object.keys(ICON_MAPPING),
      visible_radius: 500,
      search_uid: "",
    },
  });

  const {
    clickedPointIconObjects,
    widgetState,
    setPointsLayerFilterFunc,
    setVisibleRadius,
    setClickedPointIconObjects,
    viewState,
    setIsClusteringPoint,
  } = mapProps;

  const { zoom } = viewState;

  const [countedClsNames, setCountedClsNames] = useState();

  useEffect(() => {
    if (zoom < 13) {
      infoByZoom();
    } else if (zoom >= 13) {
      message.destroy();
    }
    // zoom이 15이하일 때는 클러스터링 보기, 초과부터 아이콘 보기
    if (zoom <= 15) {
      setIsClusteringPoint(true);
    } else if (zoom > 15) {
      setIsClusteringPoint(false);
    }
  }, [zoom]);

  useEffect(() => {
    const { cls_code_list, visible_radius, search_uid } = widgetState;
    // console.log('cls_code of widgetState: ', cls_code);
    // console.log('search_uid of widgetState: ',search_uid);
    if (search_uid) {
      setPointsLayerFilterFunc(() => ({ uid, cls_code }) => {
        if (cls_code_list.includes(cls_code) && uid === search_uid) return true;
      });
    } else {
      setPointsLayerFilterFunc(
        () =>
          ({ cls_code }) =>
            cls_code_list.includes(cls_code)
      );
    }
    setVisibleRadius(visible_radius);
  }, [widgetState]);

  const onClickedPointInWidgetTable = useCallback(
    (feature) => {
      const { latitude, longitude } = feature;
      const newLongitude = positionToDegress(longitude);
      const newLatitude = positionToDegress(latitude);
      const newFeature = { ...feature, position: [newLongitude, newLatitude] };
      setClickedPointIconObjects([newFeature]);

      setTimeout(() => {
        if (closeButtonRef.current) {
          closeButtonRef.current.focus();
        }
      }, 3000);
    },
    [setClickedPointIconObjects]
  );

  useEffect(() => {
    // eslint-disable-next-line array-callback-return
    const clsNames = clickedPointIconObjects.map(({ cls_code }) => {
      if (cls_code === "21") return "고정국";
      if (cls_code === "32") return "기지국";
      if (cls_code === "85") return "이동중계국";
      if (cls_code === "92") return "아마추어국";
      //     if(cls_code === '81') return '전파응용1';
      //     if(cls_code === '82') return '전파응용1';
      //     if(cls_code === '83') return '전파응용1';
    });

    const countedClsNames = clsNames.reduce((allName, name) => {
      if (name in allName) {
        allName[name]++;
      } else {
        allName[name] = 1;
      }
      return allName;
    }, {});
    setCountedClsNames(countedClsNames);
  }, [clickedPointIconObjects]);

  const closeButtonRef = useRef();

  return (
    <MapPropsProvider value={mapProps}>
      <MapBase>
        <WidgetContainer tabIndex={298}>
          <div title={"주소 검색"}>
            <WidgetGeocoding 
              onLocationSelectTriggerTable={() => setTableVisible(true)}
            />
            <Seperator />
            <WidgetClsCode options={CLS_CODE_OPTIONS} iconCodeByClsCode={ICON_CODE_BY_CLS_CODE} />
            <Seperator />
            <WidgetVisibleRadius />
          </div>
        </WidgetContainer>

        <WidgetTableClicked
          closeButtonRef={closeButtonRef}
          fetchUrl={getApiUrl({ type: "type2" })}
          clsInfo={countedClsNames}
          getTitle={(objects) => `${objects.length}개의 무선국`}
          objects={clickedPointIconObjects}
          getRow={({ uid, address, cls_name, rds_svc_form_nm }) => (
            <div>
              <table>
                <tbody>
                  <tr>
                    <th>허가번호</th>
                    <td>{formatUid(uid)}</td>
                  </tr>
                  <tr>
                    <th>국종</th>
                    <td>{cls_name}</td>
                  </tr>
                  <tr>
                    <th>설(상)치장소</th>
                    <td>{address}</td>
                  </tr>
                  <tr>
                    <th>용도</th>
                    <td>{rds_svc_form_nm}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
        />

        <WidgetTableForSecureZone
          visible={isTableVisible}
          setVisible={setTableVisible}
          fetchUrl={getApiUrl({ type: "type1" })}
          getTitle={(layer) => `${layer.length}개의 무선국`}
          widgetTabIndex={TI_WIDGET_TABLE}
          columns={[
            {
              title: "순번",
              dataIndex: "index",
              key: "index",
              width: 80,
              fixed: "left",
              align: "center",
              // sorter: makeTableSorterFn("index"),
            },
            {
              title: "허가번호",
              dataIndex: "uid",
              key: "uid",
              width: 200,
              fixed: "left",
              // render: (uid, feature) =>
              //   WidgetUidWithShortcut({
              //     feature,
              //     onClick: onClickedPointInWidgetTable,
              //   }),
              // sorter: makeTableSorterFn("uid"),
            },
            {
              title: "무선국종",
              dataIndex: "cls_name",
              key: "cls_name",
              // sorter: makeTableSorterFn("cls_name"),
            },
            {
              title: "설(상)치장소",
              dataIndex: "address",
              key: "address",
              render: (address) => (
                <WidgetButton>
                  <EllipsisText text={address} />
                </WidgetButton>
              ),
              // sorter: makeTableSorterFn("address"),
            },
            {
              title: "용도",
              dataIndex: "rds_svc_form_nm",
              key: "rds_svc_form_nm",
              width: 400,
              // sorter: makeTableSorterFn("rds_svc_form_nm"),
            },
            {
              title: "위도",
              dataIndex: "latitude",
              key: "latitude",
              width: 140,
            },
            {
              title: "경도",
              dataIndex: "longitude",
              key: "longitude",
              width: 140,
            },
          ]}
        />

        <WidgetVworldCityTypeForCenter />

        <WidgetLegend />
      </MapBase>
      <WidgetToolbar />
    </MapPropsProvider>
  );
};

export default MapStation;
